const RFID_VALIDATION_MIN_LENGTH = 6;
const RFID_VALIDATION_MAX_LENGTH = 30;

export interface RfidValidationParams {
  rfidNumber: string;
  name: string;
  error?: string | null;
  isLoading?: boolean;
}

export const validateRfidValues = ({
  rfidNumber,
  name,
  error,
  isLoading = false,
}: RfidValidationParams): {
  validRfidNumber: boolean;
  validName: boolean;
  isValid: boolean;
} => {
  const validRfidNumber =
    rfidNumber.length >= RFID_VALIDATION_MIN_LENGTH &&
    rfidNumber.length <= RFID_VALIDATION_MAX_LENGTH;

  const validName = name.trim().length > 0;
  const isValid = validRfidNumber && validName && !error && !isLoading;

  return {
    validRfidNumber,
    validName,
    isValid,
  };
};
